import { useQuery } from '@tanstack/react-query';

import { getCommissionerChannelDataByUser } from '~/services/commissioner/commissioner-service.service.api';

import { GroupEntriesQueryKeys } from '../constants/query';

const STALE_TIME = 30_000;

export const useCurrentUserChannel = (userId?: string) => {
  const { data, isLoading } = useQuery({
    enabled: Boolean(userId),
    queryKey: GroupEntriesQueryKeys.currentUserChannel(userId ?? ''),
    queryFn: ({ signal }) => getCommissionerChannelDataByUser(signal),
    staleTime: STALE_TIME,
    retry: false,
  });

  return {
    channel: data?.data,
    isLoading,
  };
};
